module.exports = __webpack_public_path__ + "static/img/12.57b3a5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/12.png
// module id = 5hLd
// module chunks = 0